import axios from "axios";
import {getField, updateField} from "vuex-map-fields";
import i18n from '@/i18n';
import Vue from "vue";

export default {
    namespaced: true,
    state: {
        fetched: false,
        savingInProgress: false,
        paymentsTypes:[],
        payment: {
            type: null,
            value: null,
            customer_id: null
        }
    },
    getters:{
        getField, //vuex-map-fields
    },
    mutations: {
        updateField, //vuex-map-fields
    },
    actions: {
        getPaymentTypes({ commit, state, dispatch }, payload){
            updateField(state, {path:'fetched', value:true});
            let link;
            if(!payload){
                payload = {};
                payload.type = null;
            }
            switch(payload.type)
            {
                case 'all':
                    link = '/payment-types/all';
                    break;
                default:
                    link = '/payment-types';
                    break;
            }
            axios.get(this._vm.$apiURL + link)
                .then((response) => {
                    updateField(state, {path:'paymentsTypes', value:response.data});
                })
                .catch((error) => {
                    dispatch('common/showError', {'error': error}, {root:true});
                })
        },
        clear({ commit, state, dispatch }){
            updateField(state, {path:'payment', value:{
                    type: null,
                    value: null,
                    customer_id: null
                }});
        },
        async addPayment({commit, state, dispatch}, payload) {
            updateField(state, {path: "savingInProgress", value: true});
            return await axios
                .post(
                    this._vm.$apiURL + "/orders/" + payload.order_id + "/add-payment",
                    payload
                )
                .then((response) => {
                    if(response && response.data && response.data.status==='success') {
                        this._vm.$inform(this._vm.i18n.t("common.operation_success"));
                        return true;
                    }
                })
                .catch((error) => {
                    dispatch("common/showError", {error: error}, {root: true});
                })
                .finally(() => {
                    updateField(state, {path: "savingInProgress", value: false});
                });
        },
        async deletePayment({ commit, state, dispatch }, payload){
            await this._vm.$confirm( {
                title : this._vm.i18n.t('common.confirm'),
                text : this._vm.i18n.t('common.confirm_remove'),
                cancelText : this._vm.i18n.t('common.no'),
                acceptText : this._vm.i18n.t('common.yes')
            } ).then( async y  =>{
                updateField(state, {path: "savingInProgress", value: true});
                return await axios.delete(this._vm.$apiURL+'/payments/'+payload.id)
                    .then(response => {
                        if(response.data.status==='success'){
                            this._vm.$inform( this._vm.i18n.t('common.success_remove') );
                        }
                    })
                    .catch(error => {
                        dispatch('common/showError', {'error': error}, {root:true});
                    })
                    .finally(() => {
                        updateField(state, {path: "savingInProgress", value: false});
                    });
            }).catch( n => {} );
        },
    }
}
